import Http from "./index";

export const reserveAppointment = (params = "") =>
  Http.put(`/slot/${params.id}`);
export const searchAppointment = (params = "") =>
  Http.get(`/slot?occupation=${params.professional}`);
export const myAppointment = (params = "") => Http.get(`/schedule?limit=100`);
export const cancelAppointment = (params = "") =>
  Http.delete(`/schedule/${params.id}`);
